const COLOR_REPRESENTATIONS = {
  BRANDBOOK_VAR: 'BRANDBOOK_VAR',
  BRANDBOOK_RGBA_STRING: 'RGBA',
  BRANDBOOK_RGBA_OBJ: 'OBJ',
  BRANDBOOK_HSLA_OBJ: 'HSLA'
}

export default COLOR_REPRESENTATIONS
